import request, {requestJson} from '../main';
const service = ""
class AuditApi {
    private url: string = service + "/audit";
    //提交审核
    public submitAuditOrder(args: any){
        return requestJson({
            url: this.url + '/submit-audit-order',
            method: 'post',
            data: args
        })
    }
    //审核列表
    public list(args: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    //列表中器具详情
    public listOrderDetails(args: any){
        return request({
            url: this.url + '/list-order-details',
            method: 'get',
            params: args
        })
    }

    //备案列表
    public auditOrders(args: any){
        return request({
            url: this.url + '/audit-orders',
            method: 'get',
            params: args
        })
    }
    //订单分配
    public auditOrderDistribute(args: any){
        return request({
            url: this.url + '/audit-order-distribute',
            method: 'post',
            data: args
        })
    }
    //备案详情
    public getOrderDetail(args: any){
        return request({
            url: this.url + '/get-order-detail',
            method: 'get',
            params: args
        })
    }
    //审核员更新审核状态
    public checkOrder(args: any){
        return request({
            url: this.url + '/checkOrder',
            method: 'post',
            data: args
        })
    }
    //删除订单
    public deleteAuditOrder(args: any){
        return request({
            url: this.url + '/delete-audit-order',
            method: 'post',
            data: args
        })
    }
    //退回
    public returnAuditOrder(args: any){
        return request({
            url: this.url + '/return-audit-order',
            method: 'get',
            params: args
        })
    }
    //提交备案前获取目标行政单位
    public getAudit(args: any){
        return request({
            url: this.url + '/get-audit',
            method: 'get',
            params: args
        })
    }
    //备案不通过的接口
    public orderNotPass(args: any){
        return requestJson({
            url: this.url + '/order-not-pass',
            method: 'post',
            data: args
        })
    }
}
const auditApi = new AuditApi();
export {auditApi}
